import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  Box,
  Paper
} from '@mui/material';
import {
  Search,
  Accessibility,
  Person,
  Crop,
  Inventory2,
  PhotoCamera,
  Videocam,
  Palette,
  Brush,
  Architecture,
  AutoFixHigh,
  ColorLens,
  Style,
  Memory,
  SmartDisplay,
  Bolt,
  Psychology,
  Circle,
  Star,
  Favorite,
  Cake,
  LocalFlorist,
  Watch,
  Category,
  ShoppingBag,
  Storefront,
  Store,
  Business,
  Work,
  Build,
  Settings,
  Home,
  Apartment,
  LocalOffer,
  Label,
  Bookmark,
  Flag,
  Grade,
  AutoAwesome,
  Terrain,
  Landscape,
  Nature,
  WbSunny,
  Nightlight,
  Cloud,
  Park,
  Opacity,
  Waves,
  WbCloudy,
  FilterHdr,
  // Gender Icons
  Male,
  Female,
  Transgender,
  Wc,
  Man,
  Woman,
  Boy,
  Girl,
  PregnantWoman,
  Elderly,
  ElderlyWoman,
  Face,
  Face2,
  Face3,
  Face4,
  Face5,
  Face6,
  People,
  PeopleOutline,
  Groups,
  ChildCare,
  ChildFriendly,
  EscalatorWarning,
  FamilyRestroom,
  BabyChangingStation,
  // Hand and Ear Icons
  Gesture,
  PanTool,
  ThumbUp,
  ThumbDown,
  // Ear and Audio Icons
  Hearing,
  VolumeUp,
  VolumeOff,
  VolumeMute,
  Headphones,
  HeadsetMic,
  HeadsetOff,
  // New Icons for Product and Themes
  Diamond,
  ShoppingCart,
  Checkroom,
  AutoGraph
} from '@mui/icons-material';


// Predefined icon options with categories
const ICON_OPTIONS = [
  // Hand Gestures
  { name: 'PanTool', icon: PanTool, category: 'Hand Gestures' },
  { name: 'ThumbUp', icon: ThumbUp, category: 'Hand Gestures' },
  { name: 'ThumbDown', icon: ThumbDown, category: 'Hand Gestures' },
  { name: 'Gesture', icon: Gesture, category: 'Hand Gestures' },
  
  // Ear & Audio
  { name: 'Hearing', icon: Hearing, category: 'Ear & Audio' },
  { name: 'VolumeUp', icon: VolumeUp, category: 'Ear & Audio' },
  { name: 'VolumeOff', icon: VolumeOff, category: 'Ear & Audio' },
  { name: 'VolumeMute', icon: VolumeMute, category: 'Ear & Audio' },
  { name: 'Headphones', icon: Headphones, category: 'Ear & Audio' },
  { name: 'HeadsetMic', icon: HeadsetMic, category: 'Ear & Audio' },
  { name: 'HeadsetOff', icon: HeadsetOff, category: 'Ear & Audio' },
  
  // Model Types
  { name: 'Accessibility', icon: Accessibility, category: 'Model Types' },
  { name: 'Person', icon: Person, category: 'Model Types' },
  { name: 'Male', icon: Male, category: 'Model Types' },
  { name: 'Female', icon: Female, category: 'Model Types' },
  { name: 'Man', icon: Man, category: 'Model Types' },
  { name: 'Woman', icon: Woman, category: 'Model Types' },
  { name: 'Boy', icon: Boy, category: 'Model Types' },
  { name: 'Girl', icon: Girl, category: 'Model Types' },
  { name: 'PregnantWoman', icon: PregnantWoman, category: 'Model Types' },
  { name: 'Elderly', icon: Elderly, category: 'Model Types' },
  { name: 'ElderlyWoman', icon: ElderlyWoman, category: 'Model Types' },
  { name: 'Transgender', icon: Transgender, category: 'Model Types' },
  { name: 'Wc', icon: Wc, category: 'Model Types' },
  { name: 'Face', icon: Face, category: 'Model Types' },
  { name: 'Face2', icon: Face2, category: 'Model Types' },
  { name: 'Face3', icon: Face3, category: 'Model Types' },
  { name: 'Face4', icon: Face4, category: 'Model Types' },
  { name: 'Face5', icon: Face5, category: 'Model Types' },
  { name: 'Face6', icon: Face6, category: 'Model Types' },
  { name: 'People', icon: People, category: 'Model Types' },
  { name: 'PeopleOutline', icon: PeopleOutline, category: 'Model Types' },
  { name: 'Groups', icon: Groups, category: 'Model Types' },
  { name: 'ChildCare', icon: ChildCare, category: 'Model Types' },
  { name: 'ChildFriendly', icon: ChildFriendly, category: 'Model Types' },
  { name: 'EscalatorWarning', icon: EscalatorWarning, category: 'Model Types' },
  { name: 'FamilyRestroom', icon: FamilyRestroom, category: 'Model Types' },
  { name: 'BabyChangingStation', icon: BabyChangingStation, category: 'Model Types' },
  { name: 'Crop', icon: Crop, category: 'Model Types' },
  { name: 'Inventory2', icon: Inventory2, category: 'Model Types' },
  { name: 'Diamond', icon: Diamond, category: 'Model Types' },
  { name: 'Checkroom', icon: Checkroom, category: 'Model Types' },

  
  // Product Categories
  { name: 'Circle', icon: Circle, category: 'Product Categories' },
  { name: 'Watch', icon: Watch, category: 'Product Categories' },
  { name: 'Favorite', icon: Favorite, category: 'Product Categories' },
  { name: 'Star', icon: Star, category: 'Product Categories' },
  { name: 'LocalFlorist', icon: LocalFlorist, category: 'Product Categories' },
  { name: 'Cake', icon: Cake, category: 'Product Categories' },
  
  // Media & Creation
  { name: 'PhotoCamera', icon: PhotoCamera, category: 'Media & Creation' },
  { name: 'Videocam', icon: Videocam, category: 'Media & Creation' },
  { name: 'Palette', icon: Palette, category: 'Media & Creation' },
  { name: 'Brush', icon: Brush, category: 'Media & Creation' },
  { name: 'Architecture', icon: Architecture, category: 'Media & Creation' },
  { name: 'AutoFixHigh', icon: AutoFixHigh, category: 'Media & Creation' },
  { name: 'ColorLens', icon: ColorLens, category: 'Media & Creation' },
  { name: 'Style', icon: Style, category: 'Media & Creation' },
  { name: 'AutoGraph', icon: AutoGraph, category: 'Media & Creation' },

  
  // Technology
  { name: 'Memory', icon: Memory, category: 'Technology' },
  { name: 'SmartDisplay', icon: SmartDisplay, category: 'Technology' },
  { name: 'Bolt', icon: Bolt, category: 'Technology' },
  { name: 'Psychology', icon: Psychology, category: 'Technology' },
  { name: 'AutoAwesome', icon: AutoAwesome, category: 'Technology' },
  
  // Business & Commerce
  { name: 'Category', icon: Category, category: 'Business & Commerce' },
  { name: 'ShoppingBag', icon: ShoppingBag, category: 'Business & Commerce' },
  { name: 'Storefront', icon: Storefront, category: 'Business & Commerce' },
  { name: 'Store', icon: Store, category: 'Business & Commerce' },
  { name: 'Business', icon: Business, category: 'Business & Commerce' },
  { name: 'Work', icon: Work, category: 'Business & Commerce' },
  
  // General
  { name: 'Build', icon: Build, category: 'General' },
  { name: 'Settings', icon: Settings, category: 'General' },
  { name: 'Home', icon: Home, category: 'General' },
  { name: 'Apartment', icon: Apartment, category: 'General' },
  { name: 'LocalOffer', icon: LocalOffer, category: 'General' },
  { name: 'Label', icon: Label, category: 'General' },
  { name: 'Bookmark', icon: Bookmark, category: 'General' },
  { name: 'Flag', icon: Flag, category: 'General' },
  { name: 'Grade', icon: Grade, category: 'General' },
  
  // Nature & Environment
  { name: 'Terrain', icon: Terrain, category: 'Nature & Environment' },
  { name: 'Landscape', icon: Landscape, category: 'Nature & Environment' },
  { name: 'Nature', icon: Nature, category: 'Nature & Environment' },
  { name: 'WbSunny', icon: WbSunny, category: 'Nature & Environment' },
  { name: 'Nightlight', icon: Nightlight, category: 'Nature & Environment' },
  { name: 'Cloud', icon: Cloud, category: 'Nature & Environment' },
  { name: 'Park', icon: Park, category: 'Nature & Environment' },
  { name: 'Opacity', icon: Opacity, category: 'Nature & Environment' },
  { name: 'Waves', icon: Waves, category: 'Nature & Environment' },
  { name: 'WbCloudy', icon: WbCloudy, category: 'Nature & Environment' },
  { name: 'FilterHdr', icon: FilterHdr, category: 'Nature & Environment' }
];

const IconPicker = ({ open, onClose, selectedIcon, onIconSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Get unique categories
  const categories = ['All', ...new Set(ICON_OPTIONS.map(icon => icon.category))];

  // Filter icons based on search term and category
  const filteredIcons = ICON_OPTIONS.filter(icon => {
    const matchesSearch = icon.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || icon.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const handleIconSelect = (iconName) => {
    onIconSelect(iconName);
    onClose();
  };

  const getIconComponent = (iconName) => {
    // First try to find in predefined options
    const iconOption = ICON_OPTIONS.find(option => option.name === iconName);
    if (iconOption) {
      return iconOption.icon;
    }
    
    // If not found in predefined options, try to dynamically import from Material-UI
    try {
      const icons = require('@mui/icons-material');
      return icons[iconName] || null;
    } catch (error) {
      console.warn('Icon not found:', iconName);
      return null;
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      aria-labelledby="icon-picker-title"
      disableAutoFocus={false}
      disableEnforceFocus={false}
      disableRestoreFocus={false}
    >
      <DialogTitle id="icon-picker-title">
        <Typography variant="h6">Select an Icon</Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            placeholder="Search icons..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              )
            }}
            sx={{ mb: 2 }}
          />
          
          {/* Category Filter */}
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
            {categories.map((category) => (
              <Button
                key={category}
                variant={selectedCategory === category ? 'contained' : 'outlined'}
                size="small"
                onClick={() => setSelectedCategory(category)}
                sx={{ textTransform: 'none' }}
              >
                {category}
              </Button>
            ))}
          </Box>
        </Box>

        {/* Current Selection */}
        {selectedIcon && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" gutterBottom>
              Current Selection:
            </Typography>
            <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              {(() => {
                const IconComponent = getIconComponent(selectedIcon);
                return IconComponent ? <IconComponent sx={{ fontSize: 24 }} /> : null;
              })()}
              <Typography>{selectedIcon}</Typography>
            </Paper>
          </Box>
        )}

        {/* Icon Grid */}
        <Grid container spacing={1}>
          {filteredIcons.map((iconOption) => {
            const IconComponent = iconOption.icon;
            const isSelected = selectedIcon === iconOption.name;
            return (
              <Grid item key={iconOption.name}>
                <IconButton
                  onClick={() => handleIconSelect(iconOption.name)}
                  sx={{
                    width: 60,
                    height: 60,
                    border: '2px solid',
                    borderColor: isSelected ? 'primary.main' : 'grey.300',
                    borderRadius: 1,
                    backgroundColor: isSelected ? 'primary.light' : 'transparent',
                    '&:hover': {
                      borderColor: 'primary.main',
                      backgroundColor: 'primary.light'
                    }
                  }}
                  title={iconOption.name}
                >
                  <IconComponent sx={{ fontSize: 24 }} />
                </IconButton>
              </Grid>
            );
          })}
        </Grid>

        {filteredIcons.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography color="text.secondary">
              No icons found matching your search criteria.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          variant="contained" 
          onClick={() => selectedIcon && handleIconSelect(selectedIcon)}
          disabled={!selectedIcon}
        >
          Confirm Selection
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IconPicker; 